module.exports = __webpack_public_path__ + "static/img/exploit12.0d929c72.png";